export function getWidgetPickerItemStyle() {
    return {
        flexContainer: {
            maxWidth: "none",
        },
        root: {
            borderRadius: "4px",
            minHeight: "48px",
            width: "284px",
        },
    };
}
export function getActionIconContainerStyles(theme, isAddSupported) {
    return {
        root: {
            "@media screen and (-ms-high-contrast: active)": {
                border: "solid 1px",
                borderColor: isAddSupported ? "buttonText" : "grayText",
            },
            alignItems: "center",
            backgroundColor: isAddSupported ? theme.customSemanticColors.accentFillDefault : theme.customSemanticColors.accentDisabled,
            borderRadius: "50%",
            display: "flex",
            height: "20px",
            justifyContent: "center",
            width: "20px",
        },
    };
}
export function getActionIconStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textOnAccentPrimary,
            display: "flex",
            fontSize: "8px",
            fontWeight: 600,
        },
    };
}
export function getIconStyles(isAddSupported) {
    return {
        image: {
            opacity: isAddSupported ? "1" : ".5",
        },
        root: {
            display: "flex",
            height: "20px",
            width: "20px",
        },
    };
}
export function getTitleStyles() {
    return {
        root: {
            display: "flex",
            height: "fit-content",
            marginBottom: "5px",
            marginTop: "5px",
            width: "194px",
        },
    };
}
export function getStackStyles() {
    return {
        root: {
            alignItems: "center",
        },
    };
}
